module.exports = __webpack_public_path__ + "img/mind_skeleton_14.13ca2bbe.png";